module.exports = __webpack_public_path__ + "static/media/siddharth-bannerghatta-zoo-trip-02.17874fb0.png";